import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { DEFAULT_PATHS } from 'config';
import { useSecurityStatus } from 'auth/SecurityGuard';

const WARNING_DAYS = 7;
const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Notice for the last days before the password expires, for NoticeCenter.
 * Needs SecurityGuard above it, which supplies passwordExpiresAt (epoch ms
 * as a string). Once expired, SecurityGuard sends the user to change it.
 * @return {Object|null}
 */
const usePasswordExpiryNotice = () => {
  const { passwordExpiresAt } = useSecurityStatus();
  const location = useLocation();

  if (!passwordExpiresAt) return null;
  const daysLeft = Math.ceil((Number(passwordExpiresAt) - Date.now()) / DAY_MS);
  if (daysLeft <= 0 || daysLeft > WARNING_DAYS) return null;

  return {
    // Keyed by the expiry date so a dismissal doesn't hide the next cycle.
    id: `password-expiry-${passwordExpiresAt}`,
    severity: 'critical',
    icon: 'lock-off',
    title: daysLeft === 1 ? 'Your password expires tomorrow' : `Your password expires in ${daysLeft} days`,
    message: 'Change it now to keep using Seller Hub without interruption.',
    action: (
      <NavLink
        className="btn btn-sm btn-outline-primary"
        to={{
          pathname: DEFAULT_PATHS.SECURITY_CHECK,
          search: '?change=password',
          state: { from: { pathname: location.pathname, search: location.search } },
        }}
      >
        Change password
      </NavLink>
    ),
    dismissible: true,
  };
};

export default usePasswordExpiryNotice;
